import { useEffect, useState } from 'react'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'
import CircularProgress from '@mui/material/CircularProgress';

function ReplicationChart({chartData}) {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  const [yTicks, setYTicks] = useState([])
  const [valueType, setValueType] = useState('Count')
  const [bottomMargin, setBottomMargin] = useState(100)

  useEffect(() => {
    setLoading(true)
    let valueKey = null;
    if(chartData?.length > 0){
        if ('count_' in chartData[0]) {
          valueKey = 'Count';
        } else if ('avg_duration' in chartData[0]) {
          valueKey = 'Avg Duration';
        } else if ('max_duration' in chartData[0]) {
          valueKey = 'Max Duration';
        } else {
          valueKey = 'Count';
        }  
        setValueType(valueKey);
      }

    setTimeout(() => {
      const formattedData = chartData.map((record) => ({
        name: record.display_name ?? record.endpoint ?? record.identifier ?? 'Unknown',
        value: record.count_ ?? record.avg_duration ?? record.max_duration ?? 0
      }));

      setData(formattedData)
      const NameCount = formattedData.map(d => d.name.length);
      const bMargin = Math.max(...NameCount)*2.5;
      setBottomMargin(bMargin);

      const values = formattedData.map(d => d.value)
      const min = Math.min(...values)
      const max = Math.max(...values)
      const ticks = [Math.floor(min)]
      for (let i = 0 ; i < 6; i++) {
        ticks.push((Math.floor(ticks[i])+(Math.floor(max/5))))
      }
      setYTicks(ticks)
      setLoading(false)
    }, 600)
  }, [chartData])

  if (loading) {
    return <div className='loading'><CircularProgress color="inherit" /></div>
  }

  return (
    <div className="chart-wrapper">
      <ResponsiveContainer width="100%" height={400}>
        <BarChart
          data={data}
          margin={{ top: 20, right: 30, left: 20, bottom:bottomMargin }}
          barSize={15}
        >
          <CartesianGrid strokeDasharray="0" vertical={false} stroke="#e5e7eb" />
          <XAxis
            dataKey="name"
            axisLine={false}
            tickLine={false}
            interval={0}
            tick={{
              fill: 'var(--chart-text)',
              fontSize: 10,
              angle: -35,
              textAnchor: 'end',
              height:300
            }}
            dy={1}
          />
          <YAxis
            domain={0}
            ticks={yTicks}
            axisLine={false}
            tickLine={false}
            tick={{ fill: 'var(--chart-text)', fontSize: 12 }}
            dx={-10}
          />
          <Tooltip
            formatter={(value) => [`${value}`, valueType]}
            cursor={{ fill: '#4848480d' }}
            contentStyle={{ backgroundColor: 'var(--bg-color)', borderColor: '#ccc', borderRadius: '3px' }}
          />
          <Bar
            dataKey="value"
            fill="#0689FF"
            radius={10}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}

export default ReplicationChart
